<template>
  <div>
    <el-dialog :title="$t('license.titles')"
               :visible.sync="showDailog"
               width="45%"
               @close="handleClose">
      <el-form :model="formList"
               label-width="180px"
               :rules="rules"
               ref="form">
        <el-form-item :label="$t('license.custormContact')"
                      prop="name">
          <el-input v-model.trim="formList.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('license.custormPhone')"
                      prop="phone">
          <el-input v-model.trim="formList.phone"></el-input>
        </el-form-item>
        <el-form-item :label="$t('license.custormEmail')"
                      prop="email">
          <el-input v-model.trim="formList.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('license.custormCompany')"
                      prop="company">
          <el-input v-model.trim="formList.company"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click.stop="sumbit">{{$t('license.save')}}</el-button>
        <el-button @click="reset">{{$t('license.reset')}}</el-button>

        <el-button type="primary"
                   @click.stop="jumpOnline"
                   v-if="type==='online'">{{$t('license.noUpdate')}}</el-button>
        <el-button type="primary"
                   @click.stop="jumpOffline"
                   v-if="type==='offline'">{{$t('license.noUpdate')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('license.titles')"
               :visible.sync="dialogShow"
               width="45%"
               @close="closeFormApply">
      <p>{{$t('license.tips')}}</p>
      <el-form label-width="180px"
               :model="formApply"
               :rules="applyRules"
               ref="apply">
        <el-form-item :label="$t('license.deviceNum')"
                      prop="devNum">
          <zk-dictionary-select type="applyDeviceNum"
                                v-model="formApply.devNum"
                                style="width:100%;"
                                :placeholder="$t('common.select')">
          </zk-dictionary-select>
        </el-form-item>
        <el-form-item :label="$t('license.apply')"
                      prop="endDay">
          <zk-dictionary-select type="applyEndDay"
                                v-model="formApply.endDay"
                                style="width:100%;"
                                :placeholder="$t('common.select')">
          </zk-dictionary-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeFormApply">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
                   @click="sumbitApp">{{$t('common.confirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('license.titles')"
               :visible.sync="offlineShow"
               width="45%"
               @close="closeOfflineDailog">
      <p>{{$t('license.updateTips')}}</p>
      <el-form ref="form"
               :model="form"
               label-width="180px">
        <el-form-item :label="$t('license.applyCode')">
          <el-input v-model="form.code"
                    type="textarea"
                    rows="5"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="doCopy">{{$t('license.copy')}}</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import * as Licese from '@/services/license'
export default {
  data () {
    return {
      formList: {},
      formApply: {
        devNum: '',
        endDay: ''
      },
      rules: {
        name: [{ required: true, message: this.$t('license.inputContant'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$t('license.inputPhone'), trigger: 'blur' }],
        email: [{ required: true, message: this.$t('license.inputEmail'), trigger: 'blur' }],
        company: [{ required: true, message: this.$t('license.inputCompany'), trigger: 'blur' }]
      },
      applyRules: {
        devNum: [{ required: true, message: this.$t('license.inputDevice'), trigger: 'blur' }],
        endDay: [{ required: true, message: this.$t('license.inputApply'), trigger: 'blur' }]
      },
      dialogShow: false,
      offlineShow: false,
      form: {
        code: ''
      }
    }
  },
  watch: {
    cusInfo: {
      handler (val) {
        this.formList = JSON.parse(JSON.stringify(val)) // 对象的深拷贝
      },
      deep: true
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    cusInfo: {
      type: Object
    },
    type: {
      type: String
    }
  },

  computed: {
    showDailog: {
      set () {
        return this.dialogVisible
      },
      get () {
        return this.dialogVisible
      }
    }
  },

  methods: {
    doCopy () {
      this.$copyText(this.form.code).then(res => {
        this.$message.success(this.$t('license.copySuc'))
      }, err => {
        this.$message.error(err)
      })
    },
    sumbitApp () {
      this.$refs.apply.validate((valid) => {
        if (valid) {
          let params = this.formApply
          Licese.sumbitApplyOnline(params).then(data => {
            if (data.code === '00000000') {
              this.$message.success(this.$t('license.applySuc'))
              this.dialogShow = false
            } else {
              this.$message.error(data.message)
            }
          }).catch(e => { console.log(e) })
        }
      })
    },
    closeFormApply () {
      this.dialogShow = false
    },
    closeOfflineDailog () {
      this.offlineShow = false
    },
    jumpOnline () {
      this.$emit('close')
      this.dialogShow = true
    },
    jumpOffline () {
      this.$emit('close')
      this.offlineShow = true
      Licese.getApplyCode().then(data => {
        if (data.code === '00000000') {
          this.form.code = data.payload.results.licenseApplyCode
        }
      })
    },
    reset () {
      this.formList.name = ''
      this.formList.phone = ''
      this.formList.email = ''
      this.formList.company = ''
    },
    handleClose () {
      this.$emit('close')
    },
    sumbit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('sumbit', this.formList)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/license/licenseDailog.vue